module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "img-fluid w-100",
    attrs: {
      "src": require("../assets/newsbanner.jpg"),
      "alt": "newsbanner"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area"
  }, [_c('div', {
    staticClass: "mbx"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "nytit pull-left"
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('menu', {
    staticClass: "menu pull-left",
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_1
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(0)
      }
    }
  }, [_vm._v("企业动态")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_2
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(1)
      }
    }
  }, [_vm._v("代理品牌动态")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left paddingleft15"
  }, [_c('a', {
    staticClass: "underline text66",
    class: {
      'cur': _vm.nav_status_3
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(2)
      }
    }
  }, [_vm._v("行业资讯")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "mbxwrap"
  }, [_c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("新闻中心")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.breadCrumbName))])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "nycon"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "news_show"
  }, [_c('div', {
    staticClass: "nstit"
  }, [_c('h1', [_vm._v(_vm._s(_vm.news_details.title))]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('span', [_vm._v("时间：" + _vm._s(_vm.news_details.updateTime))]), _vm._v(" "), _c('span', [_vm._v("来源：北京泽浩天")]), _vm._v(" "), _c('span', [_vm._v("浏览量：" + _vm._s(_vm.news_details.pageView))])])]), _vm._v(" "), _c('div', {
    staticClass: "nstxt",
    staticStyle: {
      "color": "black"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.news_details.newsContent)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "prevnext clearfix"
  }, [_c('div', {
    staticClass: "pnwrap pull-left"
  }, [_c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.getNewsDetailsPreOrNext(_vm.news_pre)
      }
    }
  }, [_vm._v("上一篇：" + _vm._s(_vm.news_pre.title))]), _vm._v(" "), _c('a', {
    staticClass: "underline",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        return _vm.getNewsDetailsPreOrNext(_vm.news_next)
      }
    }
  }, [_vm._v("下一篇：" + _vm._s(_vm.news_next.title))])]), _vm._v(" "), _c('router-link', {
    staticClass: "return pull-right underline",
    attrs: {
      "to": "/news"
    }
  }, [_vm._v("\n              返回列表\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "xgnews clearfix"
  }, [_vm._m(0), _vm._v(" "), (_vm.news_related_list != null || _vm.news_related_list != '' || _vm.news_related_list != undefined) ? _c('div', [_c('ul', {
    staticClass: "pull-left"
  }, _vm._l((_vm.news_related_list), function(list, index) {
    return (index % 2 == 0) ? _c('li', [_c('a', {
      staticClass: "myoverflow underline",
      attrs: {
        "href": "javascript:void(0);",
        "title": list.title
      },
      on: {
        "click": function($event) {
          return _vm.getNewsDetailsPreOrNext(list)
        }
      }
    }, [_vm._v(_vm._s(list.title))]), _c('span', [_vm._v("[ " + _vm._s(list.updateTime) + " ]")])]) : _vm._e()
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "pull-right"
  }, _vm._l((_vm.news_related_list), function(list, index) {
    return (index % 2 == 1) ? _c('li', [_c('a', {
      staticClass: "myoverflow underline",
      attrs: {
        "href": "javascript:void(0);",
        "title": list.title
      },
      on: {
        "click": function($event) {
          return _vm.getNewsDetailsPreOrNext(list)
        }
      }
    }, [_vm._v(_vm._s(list.title))]), _c('span', [_vm._v("[ " + _vm._s(list.updateTime) + " ]")])]) : _vm._e()
  }), 0)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pstit"
  }, [_c('span', [_vm._v("相关新闻")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eb6d93c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NewsDetails.vue
// module id = 307
// module chunks = 2